module.exports = __webpack_public_path__ + "img/global-reach.484a6aa7.png";